module.exports = __webpack_public_path__ + "images/login_icon_password@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login_icon_password@2x.png
// module id = 875
// module chunks = 130